import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useCatalogContext } from "../context/useCatalogContext";
import { FoodsIcon, FoodsIconButton } from "@foodpilot/foods";
import { EngagedActTypo } from "src/components/Actions/Common/EngagedActTypo";
import { Link } from "react-router";
import { useActionsContext } from "src/context/Actions/useActionsContext";

export const ListView = () => {
    const { urls } = useActionsContext();
    const { actionsByParents } = useCatalogContext();
    const theme = useTheme();
    return (
        <Stack
            padding={theme.spacing(2)}
            gap={theme.spacing(2)}
            divider={<Box borderTop={`1px solid ${theme.custom.grey[600]}`} />}
        >
            {actionsByParents.catalogList.map((catalogItem) => {
                const url = urls.catalogGroup(catalogItem.parent.id);

                return (
                    <Stack
                        key={catalogItem.parent.id}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                    >
                        <Stack flexDirection={"row"} gap={theme.spacing(1)} alignItems={"center"}>
                            <FoodsIcon size={4} icon={catalogItem.parent.iconName} />
                            <Typography
                                variant="body-bold"
                                sx={{
                                    // I can't seem to align properly ICON + Text...
                                    marginTop: "4px",
                                }}
                            >
                                {catalogItem.parent.title}
                            </Typography>
                        </Stack>
                        <Stack
                            flexDirection={"row"}
                            gap={theme.spacing(4)}
                            justifyContent={"center"}
                            alignItems={"center"}
                        >
                            <Stack
                                sx={{
                                    // Same problem than above with alignment of text and big icon
                                    marginTop: "4px",
                                }}
                            >
                                <EngagedActTypo
                                    engagedActions={catalogItem.engagedActions}
                                    // I need to compute it ?
                                    totalActions={catalogItem.totalActions}
                                />
                            </Stack>
                            <Link to={url}>
                                <FoodsIconButton withBackground size={"m"} icon="arrowRight" />
                            </Link>
                        </Stack>
                    </Stack>
                );
            })}
        </Stack>
    );
};
